import { EditEvent as EditEventComponent } from 'features/EditEvent';
import { PunchupEditEvent } from 'features/PunchupPages/EditEvent/PunchupEditEvent';
import { PunchupEditEvent as LegacyPunchupEditEvent } from 'features/PunchupEditEvent/PunchupEditEvent';
import { useAppSelector } from 'store/hooks';

const EditEvent = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	if (isPunchup && greenZoneEnabled) return <PunchupEditEvent />;
	if (isPunchup) return <LegacyPunchupEditEvent />;
	return <EditEventComponent />;
};
export default EditEvent;
